import React from 'react';
import '../../css/PreviewPDF.css';
import { formatPdfHeaderTimestamp, getPdfRenderTimestamp } from './pdfRenderTime';

interface PDFHeaderProps {
  renderedAt?: string;
}

const PDFHeader: React.FC<PDFHeaderProps> = ({ renderedAt }) => {
  const createdAt = formatPdfHeaderTimestamp(renderedAt || getPdfRenderTimestamp());
  return (
      <div className="pdf-header-meta">
        <span>Curated on {createdAt}</span>
        <img src="https://cdn.otaprime.com/logo-new.png" alt="OTA Prime" className="pdf-logo" />
      </div>
  );
};

export default PDFHeader;
